export const multiUploadLocaleStrings = {
  strings: {
    addMoreFiles: 'Aggiungi altri file',
    addingMoreFiles: 'Sto aggiungendo altri file',
    allowAccessDescription:
      "Per acquisire foto o video con la tua fotocamera, abilitane l'accesso da questo sito.",
    allowAccessTitle: "Abilita l'accesso alla fotocamera",
    authenticateWith: 'Connetti a %{pluginName}',
    authenticateWithTitle:
      'Autenticati con %{pluginName} per selezionare i file',
    back: 'Indietro',
    addMore: 'Aggiungi altri',
    browse: 'sfoglia',
    browseFiles: 'sfoglia',
    cancel: 'Annulla',
    cancelUpload: 'Annulla upload',
    chooseFiles: 'Scegli i file',
    closeModal: 'Chiudi modale',
    companionError: 'Connessione con Companion fallita',
    complete: 'Completato',
    connectedToInternet: 'Connesso a internet',
    copyLink: 'Copia link',
    copyLinkToClipboardFallback: "Copia l'URL sottostante",
    copyLinkToClipboardSuccess: 'Link copiato',
    creatingAssembly: 'Upload in preparazione...',
    creatingAssemblyFailed: "Transloadit: Non ho potuto creare l'Assembly",
    dashboardTitle: 'File Uploader',
    dashboardWindowTitle: 'File Uploader (Premi Esc per chiudere)',
    dataUploadedOfTotal: '%{complete} di %{total}',
    done: 'Fatto',
    dropHereOr: 'Trascina i file qui o %{browse}',
    dropHint: 'Trascina i file qui',
    dropPasteBoth: 'Trascina i file qui, incolla o %{browse}',
    dropPasteFiles: 'Trascina i file qui, incolla o %{browse}',
    dropPasteFolders: 'Trascina i file qui, incolla o %{browse}',
    dropPasteImportBoth: 'Trascina i file qui, incolla, %{browse} o importa da',
    dropPasteImportFiles:
      'Trascina i file qui, incolla, %{browse} o importa da',
    dropPasteImportFolders:
      'Trascina i file qui, incolla, %{browse} o importa da',
    editFile: 'Modifica file',
    editing: 'Modifica %{file}',
    emptyFolderAdded: 'Nessun file aggiunto dalla cartella vuota',
    encoding: 'Encoding...',
    enterCorrectUrl:
      'URL non corretta: assicurati che sia un link diretto ad un file',
    enterUrlToImport: "Immetti l'URL per importare un file",
    exceedsSize: 'Questo file supera la dimensione massima di %{size}',
    failedToFetch:
      'Impossibile verificare questa URL, assicurati che sia corretta',
    failedToUpload: 'Upload del file %{file} non riuscito',
    fileSource: 'Sorgente file: %{name}',
    filesUploadedOfTotal: {
      '0': '%{complete} di %{smart_count} file caricato',
      '1': '%{complete} di %{smart_count} file caricati',
    },
    filter: 'Filter',
    finishEditingFile: 'Finish editing file',
    folderAdded: {
      '0': 'Aggiunto %{smart_count} file da %{folder}',
      '1': 'Aggiunti %{smart_count} file da %{folder}',
    },
    import: 'Importa',
    importFrom: 'Importa da %{name}',
    loading: 'Caricamento...',
    logOut: 'Logout',
    myDevice: 'Il mio computer',
    noDuplicates:
      "Impossibile aggiungere il file duplicato '%{fileName}', esiste già",
    noFilesFound: 'Non hai file o cartelle qui',
    noInternetConnection: 'Nessuna connessione a internet',
    pause: 'Pausa',
    pauseUpload: 'Pausa upload',
    paused: 'In pausa',
    poweredBy: 'Powered by %{uppy}',
    processingXFiles: {
      '0': 'Sto processando %{smart_count} file',
      '1': 'Sto processando %{smart_count} file',
    },
    removeFile: 'Rimuovi il file',
    resetFilter: 'Ripristina filtro',
    resume: 'Riprendi',
    resumeUpload: "Riprendi l'upload",
    retry: 'Riprova',
    retryUpload: "Riprova l'upload",
    saveChanges: 'Salva le modifiche',
    selectX: {
      '0': 'Seleziona %{smart_count}',
      '1': 'Seleziona %{smart_count}',
    },
    smile: 'Sorridi!',
    startRecording: 'Inizia la registrazione del video',
    stopRecording: 'Interrompi la registrazione del video',
    takePicture: 'Scatta una foto',
    timedOut: 'Upload fermo da %{seconds} secondi, sto annullando.',
    upload: 'Upload',
    uploadComplete: 'Upload completato',
    uploadFailed: 'Upload non riuscito',
    uploadPaused: 'Upload in pausa',
    uploadXFiles: {
      '0': 'Carica %{smart_count} file',
      '1': 'Carica %{smart_count} file',
    },
    uploadXNewFiles: {
      '0': 'Carica +%{smart_count} file',
      '1': 'Carica +%{smart_count} file',
    },
    uploading: 'In caricamento',
    uploadingXFiles: {
      '0': 'Caricando %{smart_count} file',
      '1': 'Caricando %{smart_count} file',
    },
    xFilesSelected: {
      '0': '%{smart_count} file selezionato',
      '1': '%{smart_count} file selezionati',
    },
    xMoreFilesAdded: {
      '0': '%{smart_count} alto file aggiunto',
      '1': '%{smart_count} altri file aggiunti',
    },
    xTimeLeft: '%{time} rimasto',
    youCanOnlyUploadFileTypes: 'Puoi caricare solamente: %{types}',
    youCanOnlyUploadX: {
      '0': 'Puoi caricare %{smart_count} solo file',
      '1': 'Puoi caricare solo %{smart_count} file',
    },
    youHaveToAtLeastSelectX: {
      '0': 'Devi selezionare almeno %{smart_count} file',
      '1': 'Devi selezionare almeno %{smart_count} file',
    },
    selectFileNamed: 'Seleziona il file %{name}',
    unselectFileNamed: 'Deseleziona il file %{name}',
    openFolderNamed: 'Cartella aperta %{name}',
  },
}

export const formatFileName = (input: string): string =>
  input.replace(/^\d+_/, '')
export const formatDate = (dateString: string): string => {
  const date = new Date(dateString)
  const day = String(date.getDate()).padStart(2, '0')
  const month = String(date.getMonth() + 1).padStart(2, '0') // January is 0!
  const year = date.getFullYear()
  return `${day}/${month}/${year}`
}

export const getUrlWithFormat = (
  proofUrl: string,
  fileName: string
): string => {
  console.log(proofUrl, fileName)
  const fileFormatArray = fileName.split('.') || []
  const format = fileFormatArray[fileFormatArray.length - 1]
  console.log(format)

  const imageFormats = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'svg']
  if (format && imageFormats.includes(format.toLowerCase())) {
    return proofUrl
  } else {
    return `https://res.cloudinary.com/estra/image/upload/estra20dev/nuovo_mktg/icons/48px/${format}.png`
  }
}
